export function load_js_css_file(url, id, file_type) {
  return new Promise((resolve, reject) => {
    if (id && document.getElementById(id)) {
      resolve();
      return;
    }
    let element;

    if (file_type === 'js') {
      element = document.createElement('script');
      element.setAttribute('type', 'text/javascript');
      element.setAttribute('src', url);
    }
    else if (file_type === 'css') {
      element = document.createElement('link');
      element.setAttribute('rel', 'stylesheet');
      element.setAttribute('type', 'text/css');
      element.setAttribute('href', url);
    }

    if (typeof element != 'undefined') {
      element.id = id;
      document.getElementsByTagName('head')[0].appendChild(element);
      element.onload = resolve;
      element.onerror = reject;
    }
  });
}

export function loadScript(url, onload = () => {}, id = null) {
  if (id && document.getElementById(id))
    return onload();

  const scriptTag = document.createElement('script');
  scriptTag.setAttribute('src', url);
  scriptTag.id = id;
  document.head.appendChild(scriptTag);
  scriptTag.onload = onload;
}

export function loadScriptWithContents(contents, id = null, onload = () => {}) {
  if (id && document.getElementById(id))
    return onload();

  const scriptTag = document.createElement('script');
  scriptTag.innerHTML = contents;
  scriptTag.id = id;
  scriptTag.onload = onload;
  document.head.appendChild(scriptTag);
}

export function loadChargeBee() {
  loadScript('https://js.chargebee.com/v2/chargebee.js', () => {
    // eslint-disable-next-line no-undef
    Chargebee.init({
      site: 'taskmapper-test',
      publishableKey: 'test_Db3AJUoPTkSRX2fRFnsVk3r0zouSgSKZ',
    });
  }, 'chargebee-js');
}

export function loadMixpanel() {
  if (!import.meta.env.VITE_APP_MIXPANEL_TOKEN) {
    return;
  }

  // Mixpanel stub initialization (official snippet)
  (function (f, b) {
    if (!b.__SV) {
      // eslint-disable-next-line style/max-statements-per-line
      let e, g, i, h; window.mixpanel = b; b._i = []; b.init = function (e, f, c) {
        // eslint-disable-next-line style/max-statements-per-line, eqeqeq, no-unused-expressions, prefer-rest-params
        function g(a, d) { const b = d.split('.'); b.length == 2 && (a = a[b[0]], d = b[1]); a[d] = function () { a.push([d].concat(Array.prototype.slice.call(arguments, 0))); }; } let a = b; typeof c !== 'undefined' ? a = b[c] = [] : c = 'mixpanel'; a.people = a.people || []; a.toString = function (a) { let d = 'mixpanel'; c !== 'mixpanel' && (d += `.${c}`); a || (d += ' (stub)'); return d; }; a.people.toString = function () { return `${a.toString(1)}.people (stub)`; }; i = 'disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove'.split(' ');
        // eslint-disable-next-line style/max-statements-per-line, no-use-before-define, no-undef, block-scoped-var, prefer-rest-params, vars-on-top, no-var
        for (h = 0; h < i.length; h++)g(a, i[h]); const j = 'set set_once union unset remove delete'.split(' '); a.get_group = function () { function b(c) { d[c] = function () { call2_args = arguments; call2 = [c].concat(Array.prototype.slice.call(call2_args, 0)); a.push([e, call2]); }; } for (var d = {}, e = ['get_group'].concat(Array.prototype.slice.call(arguments, 0)), c = 0; c < j.length; c++)b(j[c]); return d; }; b._i.push([e, f, c]);
      // eslint-disable-next-line style/max-statements-per-line, prefer-const, no-undef
      }; b.__SV = 1.2; e = f.createElement('script'); e.type = 'text/javascript'; e.async = !0; e.src = typeof MIXPANEL_CUSTOM_LIB_URL !== 'undefined' ? MIXPANEL_CUSTOM_LIB_URL : f.location.protocol === 'file:' && '//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js'.match(/^\/\//) ? 'https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js' : '//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js'; g = f.getElementsByTagName('script')[0]; g.parentNode.insertBefore(e, g);
    }
  })(document, window.mixpanel || []);

  // Initialize with token
  window.mixpanel.init(import.meta.env.VITE_APP_MIXPANEL_TOKEN, {
    debug: false,
    track_pageview: false,
    persistence: 'localStorage',
    ignore_dnt: false,
  });
}
export function loadAtlas() {
  let t;
  const e = {
    appId: 'ux37fvhb2z',
    v: 2,
    q: [],
    call() {
      // eslint-disable-next-line prefer-rest-params
      this.q.push(arguments);
    },
  };

  window.Atlas = e;

  const n = document.createElement('script');
  n.async = true;
  n.src = 'https://app.atlas.so/client-js/atlas.bundle.js';

  const s = document.getElementsByTagName('script')[0];
  // eslint-disable-next-line prefer-const
  t = s.parentNode;

  if (t !== null && t !== undefined)
    t.insertBefore(n, s);
}

export function startAtlas(options = {}) {
  if (window.Atlas) {
    window.Atlas.call('start', {
      chat: {
        hideBubble: true,
      },
      ...options,
    });
  }
  else {
    logger.warn('Atlas is not initialized yet.');
  }
}

export function removeLoadedFile(id) {
  const element = document.getElementById(id);
  if (element) {
    element.remove();
    return true;
  }
  return false;
}
